/**
 * @generated SignedSource<<dfa77fe36f8162f551af8e206d566691>>
 * @relayHash 7a30033e87b7184373b0efdce25d44dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 72f0888f8f453d24db37f17eef905e8c0dab61e0e06f4a1bf55f9cbc74743a6a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CcpEntitlementPreDunningStatus = "IN_PRE_DUNNING" | "NOT_IN_PRE_DUNNING" | "%future added value";
export type JiraApplicationKey = "JIRA_CORE" | "JIRA_PRODUCT_DISCOVERY" | "JIRA_SERVICE_DESK" | "JIRA_SOFTWARE" | "%future added value";
export type CommerceEntitlementFilter = {
  AND?: ReadonlyArray<CommerceEntitlementFilter | null | undefined> | null | undefined;
  OR?: ReadonlyArray<CommerceEntitlementFilter | null | undefined> | null | undefined;
  inPreDunning?: boolean | null | undefined;
  inTrialOrPreDunning?: boolean | null | undefined;
};
export type editionAwarenessQuery$variables = {
  accountId: string;
  applicationKey: JiraApplicationKey;
  chargeElement: string;
  cloudId: string;
  entitlementFilter?: CommerceEntitlementFilter | null | undefined;
  productKey: string;
  shouldCheckBillingAdmin: boolean;
  shouldCheckForChangeOffering: boolean;
  shouldCheckForChargeQuantities: boolean;
  shouldCheckForCollection: boolean;
  shouldCheckForStorageUsageConfluence: boolean;
  shouldCheckForStorageUsageJira: boolean;
  shouldCheckForTrial: boolean;
  shouldCheckForUserEmail: boolean;
  shouldSkip: boolean;
};
export type editionAwarenessQuery$data = {
  readonly confluence_storage?: {
    readonly bytesUsed: AGG$Long;
  } | null | undefined;
  readonly jira?: {
    readonly attachmentStorageUsed: AGG$Long | null | undefined;
  } | null | undefined;
  readonly tenantContexts?: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly __typename: string;
        readonly experienceCapabilities?: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly latestUsageForChargeElement?: number | null | undefined;
        readonly offering?: {
          readonly trial: {
            readonly lengthDays: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly preDunning?: {
          readonly status: CcpEntitlementPreDunningStatus | null | undefined;
        } | null | undefined;
        readonly relatesFromEntitlements?: ReadonlyArray<{
          readonly entitlementId: string | null | undefined;
          readonly relationshipType: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly subscription?: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly experienceCapabilities: {
                readonly configurePaymentV2: {
                  readonly experienceUrl: string | null | undefined;
                  readonly isAvailableToUser: boolean | null | undefined;
                } | null | undefined;
              } | null | undefined;
              readonly invoiceable: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly trial: {
            readonly endTimestamp: number | null | undefined;
            readonly startTimestamp: number | null | undefined;
            readonly timeLeft: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly transactionAccount?: {
          readonly isCurrentUserBillingAdmin: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly user?: {
    readonly email?: string | null | undefined;
  } | null | undefined;
};
export type editionAwarenessQuery = {
  response: editionAwarenessQuery$data;
  variables: editionAwarenessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chargeElement"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entitlementFilter"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productKey"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckBillingAdmin"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForChangeOffering"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForChargeQuantities"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForCollection"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageUsageConfluence"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageUsageJira"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForTrial"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForUserEmail"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldSkip"
},
v15 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v16 = {
  "condition": "shouldCheckForStorageUsageJira",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "applicationKey",
              "variableName": "applicationKey"
            },
            (v15/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "attachmentStorageUsed"
        }
      ]
    }
  ]
},
v17 = {
  "condition": "shouldCheckForStorageUsageConfluence",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        (v15/*: any*/)
      ],
      "concreteType": "ConfluenceStorage",
      "kind": "LinkedField",
      "name": "confluence_storage",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "bytesUsed"
        }
      ]
    }
  ]
},
v18 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v19 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v20 = [
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "entitlementFilter"
  }
],
v21 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v22 = [
  {
    "kind": "Literal",
    "name": "offeringName",
    "value": "Standard"
  }
],
v23 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v24 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v25 = {
  "condition": "shouldCheckForChargeQuantities",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "chargeElement",
          "variableName": "chargeElement"
        }
      ],
      "kind": "ScalarField",
      "name": "latestUsageForChargeElement"
    }
  ]
},
v26 = {
  "kind": "ScalarField",
  "name": "status"
},
v27 = {
  "kind": "ScalarField",
  "name": "timeLeft"
},
v28 = {
  "kind": "ScalarField",
  "name": "startTimestamp"
},
v29 = {
  "kind": "ScalarField",
  "name": "endTimestamp"
},
v30 = {
  "kind": "ScalarField",
  "name": "invoiceable"
},
v31 = {
  "kind": "ScalarField",
  "name": "lengthDays"
},
v32 = {
  "kind": "ScalarField",
  "name": "isCurrentUserBillingAdmin"
},
v33 = {
  "kind": "ScalarField",
  "name": "relationshipType"
},
v34 = {
  "kind": "ScalarField",
  "name": "entitlementId"
},
v35 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v36 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "email"
    }
  ],
  "type": "AtlassianAccountUser"
},
v37 = {
  "kind": "ScalarField",
  "name": "id"
},
v38 = [
  (v37/*: any*/)
],
v39 = {
  "kind": "InlineFragment",
  "selections": (v38/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "name": "editionAwarenessQuery",
    "selections": [
      (v16/*: any*/),
      (v17/*: any*/),
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v18/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v19/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  {
                    "args": (v20/*: any*/),
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      {
                        "condition": "shouldCheckForChangeOffering",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "experienceCapabilities",
                            "plural": false,
                            "selections": [
                              {
                                "args": (v22/*: any*/),
                                "kind": "LinkedField",
                                "name": "changeOfferingV2",
                                "plural": false,
                                "selections": [
                                  (v23/*: any*/),
                                  (v24/*: any*/)
                                ],
                                "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
                              }
                            ]
                          }
                        ]
                      },
                      (v25/*: any*/),
                      {
                        "condition": "shouldCheckForTrial",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "preDunning",
                            "plural": false,
                            "selections": [
                              (v26/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v30/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "experienceCapabilities",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "configurePaymentV2",
                                            "plural": false,
                                            "selections": [
                                              (v24/*: any*/),
                                              (v23/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "offering",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v31/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckBillingAdmin",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "transactionAccount",
                            "plural": false,
                            "selections": [
                              (v32/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckForCollection",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "relatesFromEntitlements",
                            "plural": true,
                            "selections": [
                              (v33/*: any*/),
                              (v34/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldCheckForUserEmail",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v35/*: any*/),
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v36/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v12/*: any*/),
      (v14/*: any*/),
      (v8/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v11/*: any*/),
      (v1/*: any*/),
      (v10/*: any*/),
      (v0/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Operation",
    "name": "editionAwarenessQuery",
    "selections": [
      (v16/*: any*/),
      (v17/*: any*/),
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v18/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v19/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  {
                    "args": (v20/*: any*/),
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      {
                        "condition": "shouldCheckForChangeOffering",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "experienceCapabilities",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              {
                                "args": (v22/*: any*/),
                                "kind": "LinkedField",
                                "name": "changeOfferingV2",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/)
                                ],
                                "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
                              }
                            ]
                          }
                        ]
                      },
                      (v25/*: any*/),
                      {
                        "condition": "shouldCheckForTrial",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "preDunning",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v26/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v21/*: any*/),
                                      (v30/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "experienceCapabilities",
                                        "plural": false,
                                        "selections": [
                                          (v21/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "name": "configurePaymentV2",
                                            "plural": false,
                                            "selections": [
                                              (v21/*: any*/),
                                              (v24/*: any*/),
                                              (v23/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v38/*: any*/),
                                        "type": "CcpInvoiceGroup"
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v38/*: any*/),
                                "type": "CcpSubscription"
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "offering",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  (v31/*: any*/)
                                ]
                              },
                              (v39/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckBillingAdmin",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "transactionAccount",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v32/*: any*/),
                              (v39/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckForCollection",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "relatesFromEntitlements",
                            "plural": true,
                            "selections": [
                              (v21/*: any*/),
                              (v33/*: any*/),
                              (v34/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v37/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldCheckForUserEmail",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v35/*: any*/),
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "72f0888f8f453d24db37f17eef905e8c0dab61e0e06f4a1bf55f9cbc74743a6a",
    "metadata": {},
    "name": "editionAwarenessQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a5f51f83d12f4c0f1a8d1448a72ac404";

export default node;
